import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth, useProfile } from "@/hooks/useAuth";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Loader2, Clock, MessageCircle, LogOut } from "lucide-react";

const WHATSAPP_GROUP_URL = "https://chat.whatsapp.com/Jt1ZDHMmQjjK8mrLIYB16E?mode=gi_t";

export const Route = createFileRoute("/pending-approval")({
  component: PendingApprovalPage,
});

function PendingApprovalPage() {
  const { user, loading } = useAuth();
  const { profile, loading: pLoading } = useProfile();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !user) navigate({ to: "/auth" });
  }, [user, loading, navigate]);

  // Si ya fue aprobado, redirigir al dashboard
  useEffect(() => {
    if (!pLoading && profile?.is_approved) {
      navigate({ to: "/dashboard" });
    }
  }, [profile, pLoading, navigate]);

  async function handleSignOut() {
    await supabase.auth.signOut();
    navigate({ to: "/auth" });
  }

  if (loading || pLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/30 p-4">
      <Card className="w-full max-w-md text-center">
        <CardHeader className="pb-2">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-amber-100 dark:bg-amber-900/30">
            <Clock className="h-8 w-8 text-amber-600 dark:text-amber-400" />
          </div>
          <CardTitle className="text-xl">Tu cuenta está en revisión</CardTitle>
        </CardHeader>
        <CardContent className="space-y-5">
          <p className="text-sm text-muted-foreground">
            Gracias por registrarte en <span className="font-medium text-foreground">Finanzas en Pareja</span>.
            Estamos en versión BETA y revisamos cada cuenta manualmente antes de dar acceso.
          </p>
          <p className="text-sm text-muted-foreground">
            Te notificaremos por WhatsApp cuando tu cuenta esté activa. Mientras tanto, unite al grupo de testers para estar al tanto de novedades.
          </p>

          <a href={WHATSAPP_GROUP_URL} target="_blank" rel="noopener noreferrer" className="block">
            <Button className="w-full bg-[#25D366] hover:bg-[#1ebe5d] text-white">
              <MessageCircle className="mr-2 h-5 w-5" />
              Unirme al grupo de testers
            </Button>
          </a>

          <Button variant="ghost" size="sm" className="w-full text-muted-foreground" onClick={handleSignOut}>
            <LogOut className="mr-2 h-4 w-4" />
            Cerrar sesión
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
